import React, { useEffect, useState } from 'react';
import _ from "lodash";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import axios from '../../../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../../Nodata/Nodata";
import useFetch from '../../../../utils/useFetch';
import { TableBody } from '@mui/material';
import { HasPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../../utils/Enums.json";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

export default function RolesAdminAccount({ SendDetails, OpenTab, type, Refresh }) {

    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const { t } = useTranslation();
    const [Info, setInfo] = useState({});
    const [Permissions, setPermissions] = useState([]);
    const [OtherPermissions, setOtherPermissions] = useState([]);
    const [AllPermission, setAllPermission] = useState([]);
    const [AllOrtherPermission, setAllOrtherPermission] = useState([]);

    const [readSelectAll, setReadSelectAll] = useState(false);
    const [insertSelectAll, setInsertSelectAll] = useState(false);
    const [modifySelectAll, setModifySelectAll] = useState(false);
    const [deleteSelectAll, setDeleteSelectAll] = useState(false);

    // const { data: resp, loading, error, } = useFetch("RolesAndPermissions/GetRolesAndPermissions?orgType=" + SendDetails?.organizationType + "&roleId=" + SendDetails?.roleId + "&roleName=" + SendDetails?.roleName)

    // useEffect(() => {
    //     setSpinner(!spinner);
    //     console.log(resp?.data?.data);
    //     if (resp?.data?.data) {  
    //         setInfo(resp?.data?.data);
    //         setReadSelectAll(resp?.data?.data?.readSelectAll);
    //         setInsertSelectAll(resp?.data?.data?.insertSelectAll);
    //         setModifySelectAll(resp?.data?.data?.modifySelectAll);
    //         setDeleteSelectAll(resp?.data?.data?.deleteSelectAll);
    //         setPermissions(resp?.data?.data?.permissions);
    //         setOtherPermissions(resp?.data?.data?.otherPermissions);
    //         setSpinner(spinner);
    //     }
    // }, [resp, Refresh]);

    useEffect(() => {
        setSpinner(!spinner);
        axios.get("RolesAndPermissions/GetRolesAndPermissions?orgType=" + SendDetails?.organizationType + "&roleId=" + SendDetails?.roleId + "&roleName=" + SendDetails?.roleName)
            .then((res) => {
                setInfo(res?.data?.data);
                setReadSelectAll(res?.data?.data?.readSelectAll);
                setInsertSelectAll(res?.data?.data?.insertSelectAll);
                setModifySelectAll(res?.data?.data?.modifySelectAll);
                setDeleteSelectAll(res?.data?.data?.deleteSelectAll);
                setPermissions(res?.data?.data?.permissions);
                setOtherPermissions(res?.data?.data?.otherPermissions);
                setSpinner(spinner);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [Refresh]);


    const ChangePermission = (id, val, type, isCommit = true) => {
        id[type] = val;
        if (type != "readPermission" && val)
            id["readPermission"] = true;

        if (type == "readPermission" && !val) {
            id["insertPermission"] = false;
            id["modifyPermission"] = false;
            id["deletePermission"] = false;
        }
        if (isCommit) {
            const data = _.cloneDeep(Permissions);

            setPermissions(data);
            setAllPermission(data);
        }
    };
    const ChangeAllPermission = (val, type) => {
        if (type == "readPermission") {
            setReadSelectAll(val);
            ChangeAllOtherPermissions(val, type);
        }
        else if (type == "insertPermission") {
            setInsertSelectAll(val)
        } else if (type == "modifyPermission") {
            setModifySelectAll(val)
        } else if (type == "deletePermission") {
            setDeleteSelectAll(val)
        }
        if (type != "readPermission" && val) {
            setReadSelectAll(true)
        } else if (type == "readPermission" && !val) {
            setInsertSelectAll(false)
            setModifySelectAll(false)
            setDeleteSelectAll(false)
        }


        for (var i = 0; i < Permissions.length; i++) {
            ChangePermission(Permissions[i], val, type, false);
        }
        const data = _.cloneDeep(Permissions);
        setPermissions(data);
        setAllPermission(data);
    };


    const ChangeOtherPermissions = (id, val, type, isCommit = true) => {
        id[type] = val;
        if (isCommit) {
            const data = _.cloneDeep(OtherPermissions);
            setOtherPermissions(data);
            setAllOrtherPermission(data);
        }
    };
    const ChangeAllOtherPermissions = (val, type) => {
        if (type == "readPermission") {
            setReadSelectAll(val)
        }
        for (var i = 0; i < OtherPermissions.length; i++) {
            ChangeOtherPermissions(OtherPermissions[i], val, type, false);
        }
        const data = _.cloneDeep(OtherPermissions);

        setOtherPermissions(data);
        setAllOrtherPermission(data);
    };


    const SavePermissions = async () => {

        const permissions = AllPermission?.map((r) => {
            return {
                "viewId": r?.viewId,
                "viewName": r?.viewName,
                "readPermission": r?.readPermission,
                "insertPermission": r?.insertPermission,
                "modifyPermission": r?.modifyPermission,
                "deletePermission": r?.deletePermission
            }
        })
        const otherPermissions = AllOrtherPermission?.map((r) => {
            return {
                "viewId": r?.viewId,
                "viewName": r?.viewName,
                "readPermission": r?.readPermission,
                "insertPermission": r?.insertPermission,
                "modifyPermission": r?.modifyPermission,
                "deletePermission": r?.deletePermission
            }
        })

        const obj = {
            "permissionName": Info?.permissionName,
            "roleId": Info?.roleId,
            "roleName": Info?.roleName,
            "organizationType": Info?.organizationType,
            "permissions": permissions,
            "otherPermissions": otherPermissions,
            "checksNotAvailable": Info?.checksNotAvailable,
            "readSelectAll": readSelectAll,
            "insertSelectAll": insertSelectAll,
            "modifySelectAll": modifySelectAll,
            "deleteSelectAll": deleteSelectAll,
            "isReadOnly": Info?.isReadOnly
        };
        if (AllPermission != "" && AllPermission?.some((r) => r?.readPermission == true)) {
            const res = await axios.post("RolesAndPermissions/AddOrUpdatePermissions", obj)
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                OpenTab();
            } else {
                toastNotify(res?.data?.responseMessage, false);
            }

        } else if (AllPermission == "") {
            const res = await axios.post("RolesAndPermissions/AddOrUpdatePermissions", obj)
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                OpenTab();
            } else {
                toastNotify(res?.data?.responseMessage, false);
            }
        } else {
            toastNotify("Please select atleast one permission", false);
        }
    }
    const [spinner, setSpinner] = React.useState(false);
    const SpinnerClose = () => {
        setSpinner(false);
    };
    return (
        <>
            {/* <ToastContainer /> */}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box
                sx={{ display: "flex", alignItems: "center", padding: "20px", "& hr": { mx: 0.5, }, }}>
                <h4 style={{ marginRight: "auto", marginLeft: "-18px" }}>{Info?.roleName} - Permissions</h4>
            </Box>

            <Box sx={{ backgroundColor: '#f8f9fa' }} >
                <TableContainer component={Paper} className="mb-3">
                    <h5 className='mx-3 my-3' variant="contained">{t("RolesAdmin.permissions")}</h5>
                    <Table aria-label="customized table" >
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >{t("RolesAdmin.view")}</StyledTableCell>
                                <StyledTableCell ><FormControlLabel disabled={type == 1} control={<Checkbox checked={readSelectAll} onChange={(e) => ChangeAllPermission(e.target.checked, "readPermission")} />} />{t("RolesAdmin.read")} </StyledTableCell>
                                <StyledTableCell ><FormControlLabel disabled={type == 1} control={<Checkbox checked={insertSelectAll} onChange={(e) => ChangeAllPermission(e.target.checked, "insertPermission")} />} />{t("RolesAdmin.insert")}</StyledTableCell>
                                <StyledTableCell ><FormControlLabel disabled={type == 1} control={<Checkbox checked={modifySelectAll} onChange={(e) => ChangeAllPermission(e.target.checked, "modifyPermission")} />} />{t("RolesAdmin.modify")}</StyledTableCell>
                                <StyledTableCell ><FormControlLabel disabled={type == 1} control={<Checkbox checked={deleteSelectAll} onChange={(e) => ChangeAllPermission(e.target.checked, "deletePermission")} />} />{t("RolesAdmin.delete")}</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Permissions?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : Permissions?.map((r, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ width: "40%" }}>{r?.viewName}</TableCell>
                                    <TableCell sx={{ width: "15%" }}>
                                        <FormControlLabel disabled={type == 1} control={<Checkbox checked={r?.readPermission} onChange={(e) => ChangePermission(r, e.target.checked, "readPermission")} />} />
                                    </TableCell>
                                    <TableCell sx={{ width: "15%" }}>
                                        <FormControlLabel disabled={type == 1} control={<Checkbox checked={r?.insertPermission} onChange={(e) => ChangePermission(r, e.target.checked, "insertPermission")} />} />
                                    </TableCell>
                                    <TableCell sx={{ width: "15%" }}>
                                        <FormControlLabel disabled={type == 1} control={<Checkbox checked={r?.modifyPermission} onChange={(e) => ChangePermission(r, e.target.checked, "modifyPermission")} />} />
                                    </TableCell>
                                    <TableCell align="left">
                                        <FormControlLabel disabled={type == 1} control={<Checkbox checked={r?.deletePermission} onChange={(e) => ChangePermission(r, e.target.checked, "deletePermission")} />} />
                                    </TableCell>
                                </TableRow>

                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TableContainer component={Paper} className="mb-3">
                    <h5 className='mx-3 my-3' variant="contained">{t("RolesAdmin.OtherPermissions")}</h5>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >{t("RolesAdmin.other")}</StyledTableCell>
                                {/* <StyledTableCell ><FormControlLabel control={<Checkbox disabled={type == 1} checked={readSelectAll} onChange={(e) => ChangeAllOtherPermissions(e.target.checked, "readPermission")} />} />{t("RolesAdmin.all")} </StyledTableCell> */}
                                <StyledTableCell >{t("RolesAdmin.all")} </StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {OtherPermissions?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : OtherPermissions?.map((r, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ width: "40%" }}>{r?.viewName}</TableCell>
                                    <TableCell sx={{ width: "15%" }}>
                                        <FormControlLabel control={<Checkbox disabled={type == 1} checked={r?.readPermission} onChange={(e) => ChangeOtherPermissions(r, e.target.checked, "readPermission")} />} />
                                    </TableCell>
                                    <TableCell sx={{ width: "15%" }}>  &nbsp;</TableCell>
                                    <TableCell sx={{ width: "15%" }}>  &nbsp;</TableCell>
                                    <TableCell align="left"> &nbsp;</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <Stack spacing={2} direction="row" sx={{ float: "right", padding: "10px" }}>
                        {HasPermissions(INFO?.AddOrEditPermissions?.actionName, PER?.ScreenPermissions?.Modify) &&
                            <Button
                                variant="contained"
                                color="primary"
                                hidden={type == 1}
                                style={{ textTransform: "capitalize", padding: "15px" }}
                                onClick={SavePermissions}
                            >
                                {t("RolesAdmin.save")}
                            </Button>
                        }
                        <Button variant="contained" style={{ textTransform: "capitalize", padding: "15px" }} onClick={OpenTab}>Back</Button>
                    </Stack>
                </TableContainer>
            </Box >

        </>

    )
}
